import { getTooltipAttributes } from "@common/contexts/Tooltip";
import { IconAction } from "@common/controls/Icon/component";
import { IconType } from "@common/declarations";
import withDropdownHOC, { type WithDropdownToggleProps } from "@common/hocs/withDropdown";
import React from "react";
import FixedMenuButton from "../FixedMenuButton";
import { type RichEditorToolbarFixedButton, type RichEditorToolbarMenu } from "../types";

const Content = <T extends any>(props: Props<T>) => (
  <ul className="select_options select_static" onMouseDown={(e) => e.preventDefault()}>
    {props.items.map(props.renderItem)}
  </ul>
);

const Toggle = <T extends any>(props: Props<T> & WithDropdownToggleProps) => (
  <div
    ref={props.toggleRef}
    className="item"
    onMouseDown={(e) => (e.preventDefault(), props.toggleOpen())}
    {...getTooltipAttributes(props.tooltip)}
  >
    <IconAction icon={props.icon} size={28} />
  </div>
);

type Props<T> = {
  icon: IconType;
  items: T[];
  renderItem: (item: T) => React.ReactNode;
  tooltip?: string;
};
const DropdownButton = withDropdownHOC(Toggle, Content);

export default DropdownButton;

type DropdownMenuButtonProps = {
  dropdownClassName?: string;
  menu: RichEditorToolbarMenu;
};
export const DropdownMenuButton = (props: DropdownMenuButtonProps) => {
  const renderItem = React.useCallback((x: RichEditorToolbarFixedButton) => <FixedMenuButton format={x} key={x} />, []);

  return (
    <DropdownButton
      behaviour="close"
      dropdownClassName={props.dropdownClassName}
      icon={props.menu.icon}
      tooltip={props.menu.tooltip}
      items={props.menu.items}
      renderItem={renderItem}
    />
  );
};
